module.exports = __webpack_public_path__ + "9db9cfefe750f52671b3214207ccdaa8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/round.png
// module id = 1214
// module chunks = 0